// Системні enum-и: ОДИН файл на enum — значення + _VALUES + _LABELS (+ _TONES для статусів).
// Значення ідентичні Prisma enum-ам apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts).
// Переліки, які університет доповнює, — НЕ тут, а класифікатори Dictionary (apps/api/prisma/dictionaries.ts, SPEC розд. 4).
export * from './tone.js';
export * from './role.js';
export * from './schedule-status.js';
export * from './run-status.js';
export * from './generation-mode.js';
export * from './parity.js';
export * from './study-mode.js';
export * from './audience-kind.js';
export * from './availability-kind.js';
export * from './approval-step.js';
export * from './approval-status.js';
export * from './conflict-severity.js';
export * from './conflict-code.js';
export * from './entry-source.js';
export * from './exception-kind.js';
export * from './curriculum-status.js';
export * from './assignment-status.js';
export * from './assignment-teacher-role.js';
export * from './travel-source.js';
export * from './calendar-scope.js';
export * from './rule-scope.js';
export * from './schedule-scope-kind.js';
export * from './student-status.js';
export * from './audit-action.js';
export * from './import-status.js';
export * from './outbox-status.js';
export * from './notification-type.js';
export * from './schedule-object-kind.js';
import { ROLE_VALUES, ROLE_LABELS } from './role.js';
import { SCHEDULE_STATUS_VALUES, SCHEDULE_STATUS_LABELS, SCHEDULE_STATUS_TONES } from './schedule-status.js';
import { RUN_STATUS_VALUES, RUN_STATUS_LABELS, RUN_STATUS_TONES } from './run-status.js';
import { GENERATION_MODE_VALUES, GENERATION_MODE_LABELS } from './generation-mode.js';
import { PARITY_VALUES, PARITY_LABELS } from './parity.js';
import { STUDY_MODE_VALUES, STUDY_MODE_LABELS } from './study-mode.js';
import { AUDIENCE_KIND_VALUES, AUDIENCE_KIND_LABELS } from './audience-kind.js';
import { AVAILABILITY_KIND_VALUES, AVAILABILITY_KIND_LABELS, AVAILABILITY_KIND_TONES } from './availability-kind.js';
import { APPROVAL_STEP_VALUES, APPROVAL_STEP_LABELS } from './approval-step.js';
import { APPROVAL_STATUS_VALUES, APPROVAL_STATUS_LABELS, APPROVAL_STATUS_TONES } from './approval-status.js';
import { CONFLICT_SEVERITY_VALUES, CONFLICT_SEVERITY_LABELS, CONFLICT_SEVERITY_TONES } from './conflict-severity.js';
import { CONFLICT_CODE_VALUES, CONFLICT_CODE_LABELS } from './conflict-code.js';
import { ENTRY_SOURCE_VALUES, ENTRY_SOURCE_LABELS } from './entry-source.js';
import { EXCEPTION_KIND_VALUES, EXCEPTION_KIND_LABELS, EXCEPTION_KIND_TONES } from './exception-kind.js';
import { CURRICULUM_STATUS_VALUES, CURRICULUM_STATUS_LABELS, CURRICULUM_STATUS_TONES } from './curriculum-status.js';
import { ASSIGNMENT_STATUS_VALUES, ASSIGNMENT_STATUS_LABELS, ASSIGNMENT_STATUS_TONES } from './assignment-status.js';
import { ASSIGNMENT_TEACHER_ROLE_VALUES, ASSIGNMENT_TEACHER_ROLE_LABELS } from './assignment-teacher-role.js';
import { TRAVEL_SOURCE_VALUES, TRAVEL_SOURCE_LABELS, TRAVEL_SOURCE_TONES } from './travel-source.js';
import { CALENDAR_SCOPE_VALUES, CALENDAR_SCOPE_LABELS } from './calendar-scope.js';
import { RULE_SCOPE_VALUES, RULE_SCOPE_LABELS } from './rule-scope.js';
import { SCHEDULE_SCOPE_KIND_VALUES, SCHEDULE_SCOPE_KIND_LABELS } from './schedule-scope-kind.js';
import { STUDENT_STATUS_VALUES, STUDENT_STATUS_LABELS, STUDENT_STATUS_TONES } from './student-status.js';
import { AUDIT_ACTION_VALUES, AUDIT_ACTION_LABELS } from './audit-action.js';
import { IMPORT_STATUS_VALUES, IMPORT_STATUS_LABELS, IMPORT_STATUS_TONES } from './import-status.js';
import { OUTBOX_STATUS_VALUES, OUTBOX_STATUS_LABELS, OUTBOX_STATUS_TONES } from './outbox-status.js';
import { NOTIFICATION_TYPE_VALUES, NOTIFICATION_TYPE_LABELS } from './notification-type.js';
import { SCHEDULE_OBJECT_KIND_VALUES, SCHEDULE_OBJECT_KIND_LABELS } from './schedule-object-kind.js';
/** Реєстр системних enum-ів за іменем Prisma enum. */
export const ENUM_REGISTRY = {
    Role: { values: ROLE_VALUES, labels: ROLE_LABELS },
    ScheduleStatus: { values: SCHEDULE_STATUS_VALUES, labels: SCHEDULE_STATUS_LABELS, tones: SCHEDULE_STATUS_TONES },
    RunStatus: { values: RUN_STATUS_VALUES, labels: RUN_STATUS_LABELS, tones: RUN_STATUS_TONES },
    GenerationMode: { values: GENERATION_MODE_VALUES, labels: GENERATION_MODE_LABELS },
    Parity: { values: PARITY_VALUES, labels: PARITY_LABELS },
    StudyMode: { values: STUDY_MODE_VALUES, labels: STUDY_MODE_LABELS },
    AudienceKind: { values: AUDIENCE_KIND_VALUES, labels: AUDIENCE_KIND_LABELS },
    AvailabilityKind: { values: AVAILABILITY_KIND_VALUES, labels: AVAILABILITY_KIND_LABELS, tones: AVAILABILITY_KIND_TONES },
    ApprovalStep: { values: APPROVAL_STEP_VALUES, labels: APPROVAL_STEP_LABELS },
    ApprovalStatus: { values: APPROVAL_STATUS_VALUES, labels: APPROVAL_STATUS_LABELS, tones: APPROVAL_STATUS_TONES },
    ConflictSeverity: { values: CONFLICT_SEVERITY_VALUES, labels: CONFLICT_SEVERITY_LABELS, tones: CONFLICT_SEVERITY_TONES },
    ConflictCode: { values: CONFLICT_CODE_VALUES, labels: CONFLICT_CODE_LABELS },
    EntrySource: { values: ENTRY_SOURCE_VALUES, labels: ENTRY_SOURCE_LABELS },
    ExceptionKind: { values: EXCEPTION_KIND_VALUES, labels: EXCEPTION_KIND_LABELS, tones: EXCEPTION_KIND_TONES },
    CurriculumStatus: { values: CURRICULUM_STATUS_VALUES, labels: CURRICULUM_STATUS_LABELS, tones: CURRICULUM_STATUS_TONES },
    AssignmentStatus: { values: ASSIGNMENT_STATUS_VALUES, labels: ASSIGNMENT_STATUS_LABELS, tones: ASSIGNMENT_STATUS_TONES },
    AssignmentTeacherRole: { values: ASSIGNMENT_TEACHER_ROLE_VALUES, labels: ASSIGNMENT_TEACHER_ROLE_LABELS },
    TravelSource: { values: TRAVEL_SOURCE_VALUES, labels: TRAVEL_SOURCE_LABELS, tones: TRAVEL_SOURCE_TONES },
    CalendarScope: { values: CALENDAR_SCOPE_VALUES, labels: CALENDAR_SCOPE_LABELS },
    RuleScope: { values: RULE_SCOPE_VALUES, labels: RULE_SCOPE_LABELS },
    ScheduleScopeKind: { values: SCHEDULE_SCOPE_KIND_VALUES, labels: SCHEDULE_SCOPE_KIND_LABELS },
    StudentStatus: { values: STUDENT_STATUS_VALUES, labels: STUDENT_STATUS_LABELS, tones: STUDENT_STATUS_TONES },
    AuditAction: { values: AUDIT_ACTION_VALUES, labels: AUDIT_ACTION_LABELS },
    ImportStatus: { values: IMPORT_STATUS_VALUES, labels: IMPORT_STATUS_LABELS, tones: IMPORT_STATUS_TONES },
    OutboxStatus: { values: OUTBOX_STATUS_VALUES, labels: OUTBOX_STATUS_LABELS, tones: OUTBOX_STATUS_TONES },
    NotificationType: { values: NOTIFICATION_TYPE_VALUES, labels: NOTIFICATION_TYPE_LABELS },
    ScheduleObjectKind: { values: SCHEDULE_OBJECT_KIND_VALUES, labels: SCHEDULE_OBJECT_KIND_LABELS },
};
export const ENUM_NAMES = Object.keys(ENUM_REGISTRY);
/** Підпис значення enum-а (для невідомого значення — саме значення). */
export function enumLabel(name, value) {
    if (value == null)
        return '';
    const labels = ENUM_REGISTRY[name].labels;
    return labels[value] ?? value;
}
/** Тон бейджа значення enum-а (neutral, якщо тонів немає). */
export function enumTone(name, value) {
    const d = ENUM_REGISTRY[name];
    return (value != null && d.tones?.[value]) || 'neutral';
}
//# sourceMappingURL=index.js.map